import moment from "moment/moment";

export const isNotStartedYet = (startDate?: string) => {
  const inputDate = moment(startDate).startOf("day");
  const today = moment().startOf("day");

  return inputDate.isAfter(today);
};
